import React from 'react';
import InputMask from 'react-input-mask';
import { observer } from '../../shared/observer';
import { makeConsentsHelpers } from './Consents';

class SmsLoginView extends React.Component {
  state = { phone: '', code: '', step: 'phone', error: null, sending: false, resending: false, agrees: {}, resendIn: 0 };

  componentWillUnmount() {
    this._unmounted = true;
    this.stopResendTimer();
  }

  componentWillReceiveProps(next) {
    if (next.auth && next.auth.isAuthenticated) {
      this.props.onAuthed && this.props.onAuthed();
    }
  }

  setPhone = (e) => this.setState({ phone: e.target.value, error: null });
  setCode = (e) => this.setState({ code: e.target.value.replace(/\D/g, '').slice(0, 6), error: null });

  // Обратный отсчёт до возможности повторной отправки SMS (анти-спам эндпоинта).
  startResendTimer = () => {
    this.stopResendTimer();
    this.setState({ resendIn: 30 });
    this._resendTimer = setInterval(() => {
      if (this.state.resendIn <= 1) {
        this.stopResendTimer();
        this.setState({ resendIn: 0 });
      } else {
        this.setState({ resendIn: this.state.resendIn - 1 });
      }
    }, 1000);
  };

  stopResendTimer = () => {
    if (this._resendTimer) { clearInterval(this._resendTimer); this._resendTimer = null; }
  };

  sendCode = async (e) => {
    e.preventDefault();
    if (this.state.sending) return;
    const digits = this.state.phone.replace(/\D/g, '');
    if (!digits) return;
    this.setState({ sending: true, error: null });
    try {
      await this.props.auth.sendSmsCode(digits);
      if (this._unmounted) return;
      this.setState({ step: 'code', sending: false });
      this.startResendTimer();
    } catch (err) {
      if (this._unmounted) return;
      this.setState({ error: err.message || 'Не удалось отправить код', sending: false });
    }
  };

  resendCode = async (e) => {
    e.preventDefault();
    if (this.state.sending || this.state.resendIn > 0) return;
    this.setState({ resending: true });
    await this.sendCode(e); // ошибки sendCode обрабатывает сам
    if (this._unmounted) return;
    this.setState({ resending: false });
  };

  submitCode = async (e) => {
    e.preventDefault();
    if (this.state.sending) return;
    if (!this.state.code) return;
    this.setState({ sending: true, error: null });
    try {
      await this.props.auth.submitSmsCode(this.state.code);
      // onAuthed сработает через componentWillReceiveProps — компонент к этому
      // моменту уже может быть размонтирован, setState тогда пропускаем
      if (this._unmounted) return;
      this.setState({ sending: false });
    } catch (err) {
      if (this._unmounted) return;
      this.setState({ error: err.message || 'Неверный код', sending: false });
    }
  };

  render() {
    const { phoneMaskInfo } = this.props.auth;
    const mask = phoneMaskInfo.phone_mask
      ? phoneMaskInfo.phone_mask.replace(/9/g, '9')
      : '+9 (999) 999-99-99';
    if (this.state.step === 'code') {
      return (
        <form className="login-box" onSubmit={this.submitCode}>
          <div className="h1">Введите код</div>
          <p>Код отправлен на {this.state.phone}</p>
          <input
            className="input__text"
            type="tel"
            inputMode="numeric"
            value={this.state.code}
            onChange={this.setCode}
            placeholder="Код из SMS"
            autoFocus
          />
          {this.state.error && <div className="order-message">{this.state.error}</div>}
          <button
            type="submit"
            className={'btn ' + (this.state.sending || !this.state.code ? 'btn--disabled' : '') + (this.state.sending && !this.state.resending ? ' is-busy' : '')}
            disabled={this.state.sending || !this.state.code}
          >
            Войти
          </button>
          <div style={{ fontSize: 13, marginTop: 8 }}>
            {this.state.resendIn > 0 ? (
              <span style={{ color: 'var(--ng-fg-muted)' }}>Отправить снова через {this.state.resendIn} с</span>
            ) : (
              <a
                href="#"
                className={this.state.resending ? 'is-busy' : (this.state.sending ? 'is-disabled' : '')}
                aria-disabled={this.state.sending ? 'true' : null}
                onClick={this.resendCode}
              >
                Отправить код ещё раз
              </a>
            )}
            {' · '}
            <a href="#" onClick={(e) => { e.preventDefault(); this.setState({ step: 'phone', code: '', error: null }); }}>Изменить номер</a>
          </div>
        </form>
      );
    }
    const consents = makeConsentsHelpers(this);
    const canSubmit = !this.state.sending && consents.ok();
    return (
      <form className="login-box" onSubmit={(e) => { if (!canSubmit) { e.preventDefault(); return; } this.sendCode(e); }}>
        <div className="h1">Личный кабинет</div>
        <InputMask
          className="input__text"
          mask={mask}
          maskChar="_"
          value={this.state.phone}
          onChange={this.setPhone}
          type="tel"
          placeholder={mask}
          autoFocus
        />
        {this.state.error && <div className="order-message">{this.state.error}</div>}
        {consents.render()}
        <button type="submit" className={'btn ' + (canSubmit ? '' : 'btn--disabled') + (this.state.sending ? ' is-busy' : '')} disabled={!canSubmit}>
          Получить код
        </button>
      </form>
    );
  }
}

export const SmsLogin = observer(SmsLoginView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Auth/SmsLogin.jsx